import { render, staticRenderFns } from "./SingleReminderNew.vue?vue&type=template&id=1cdbccbe"
import script from "./SingleReminderNew.vue?vue&type=script&lang=js"
export * from "./SingleReminderNew.vue?vue&type=script&lang=js"
import style0 from "./SingleReminderNew.vue?vue&type=style&index=0&id=1cdbccbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports